import { useNavigate } from "react-router-dom";
import { tBodyItemStyle } from "../users/UserListItem";
import { useDispatch } from "react-redux";
import { modalActions } from "../../store/modalSlice";

import { notificationViewActions } from "../../store/services/notificationViewSlice";
import { LuTrash2 } from "react-icons/lu";
import { FiEdit } from "react-icons/fi";

const removeHtmlTags = (html) => {
    return html?.replace(/<\/?[^>]+(>|$)/g, "");
};

export default function NotificationTemplatesListItem({ notification, actions = true }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handlenotificationDelete = (e) => {
        e.stopPropagation();
        dispatch(
            modalActions.openModal({
                details: {
                    id: notification.id,
                    name: notification.title,
                    category: "notification",
                },
            })
        );
    };

    const handleRowClick = () => {
        navigate(`/notifications/templates/${notification.id}/edit`)
        // dispatch(notificationViewActions.openModal(notification));
    };

    const handleUserEditClick = () => {

    }

    const handleUserDeleteClick = () => {

    }

    return (
        <>
            <tr className="table_row" onClick={handleRowClick}>
                <td style={tBodyItemStyle} className="text-black font-medium w-[10%]">
                    {notification.id}
                </td>
                <td style={tBodyItemStyle} className="text-black font-medium w-[20%]">
                    {notification.title}
                </td>
                <td style={tBodyItemStyle} className="text-black font-medium w-[20%]">
                    {removeHtmlTags(notification.body?.slice(0, 30))}
                    {notification.body.length > 30 && "..."}
                </td>
                {actions && (
                    <td style={tBodyItemStyle} className="w-[15%]">
                        <div className="flex justify-center gap-4 text-black">
                            <div className="rounded-full w-8 h-8 text-center bg-primary relative cursor-pointer flex justify-center actions edit-action" title="Edit" onClick={handleUserEditClick}>
                                <FiEdit style={{ fontSize: '14px', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} />
                            </div>
                            <div className="rounded-full w-8 h-8 flex justify-center items-center text-center bg-primary relative cursor-pointer actions delete-action" title="Delete" onClick={handleUserDeleteClick}>
                                <LuTrash2 style={{ fontSize: '16px', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} />
                            </div>
                        </div>
                    </td>
                )}
            </tr>
        </>
    );
}